import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function CreateCouponModal({ showModal, setShowModal, createCouponByType }) {
  const [couponDetail, setCouponDetail] = useState({
    userNo: '',
    amount: '',
    count: '',
    couponType: '',
    eventName: '',
  })
  const [isError, setIsError] = useState({
    amount: '',
    count: '',
  })

  const resetForm = () => {
    setCouponDetail({
      userNo: '',
      amount: '',
      count: '',
      couponType: '',
      eventName: '',
    })
    setIsError({
      amount: '',
      count: '',
    })
  }

  const handleCloseModal = () => {
    setShowModal(false)
    resetForm()
  }

  const handleSubmitModal = () => {
    createCouponByType(couponDetail)
    resetForm()
  }

  const patten = /^\d+$/
  const COUPON_TYPE = ['WALLET', 'SAFE']

  return (
    <Modal className="fade bd-example-modal-lg" show={showModal} size="lg">
      <Modal.Header>
        <Modal.Title>สร้างคูปองใหม่</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">ชนิดของคูปอง: </label>
            <div className="col-sm-9">
              <div className="input-group mb-3 ">
                <select
                  className="form-control"
                  onChange={(e) =>
                    setCouponDetail({ userNo: '', amount: '', count: '', eventName: '', couponType: e.target.value })
                  }
                  value={couponDetail.couponType ?? 'กรุณาเลือกชนิดของคูปอง'}
                >
                  <option value="">กรุณาเลือกชนิดของคูปอง</option>
                  {COUPON_TYPE.map((type, i) => {
                    return (
                      <option key={i} value={type}>
                        {type}
                      </option>
                    )
                  })}
                  \
                </select>
              </div>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">ชื่อ event: </label>
            <div className="col-sm-9">
              <input
                type="text"
                value={couponDetail.eventName}
                className="form-control"
                placeholder="กรุณากรอกชื่อ event"
                onChange={(e) => {
                  if (e.target.value.length <= 25) {
                    setCouponDetail({ ...couponDetail, eventName: e.target.value })
                  }
                }}
              />
              <div className="text-right">
                <span className="text-grey">{couponDetail?.eventName?.length}/25</span>
              </div>
            </div>
          </div>
          {couponDetail.couponType === 'WALLET' && (
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">รหัสลูกค้า: </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  value={couponDetail.userNo}
                  className="form-control"
                  placeholder="กรุณากรอกรหัสลูกค้า"
                  onChange={(e) => {
                    setCouponDetail({ ...couponDetail, userNo: e.target.value.replace(/[^a-zA-Z0-9]+/g, '') })
                  }}
                />
              </div>
            </div>
          )}
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">
              {couponDetail.couponType === 'SAFE' ? 'เครดิตตู้เซฟ' : 'มูลค่า'}:
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                value={couponDetail.amount}
                className="form-control"
                placeholder={
                  couponDetail.couponType === 'SAFE' ? 'กรุณากรอกมูลค่าของเครดิตตู้เซฟ' : 'กรุณากรอกมูลค่าของคูปอง'
                }
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '')
                  const errorMessage =
                    couponDetail.couponType === 'SAFE'
                      ? 'กรุณากรอกมูลค่าของเครดิตตู้เซฟให้ถูกต้อง'
                      : 'กรุณากรอกจำนวนมูลค่าของคูปองให้ถูกต้อง'
                  if (e.target.value === '') {
                    setIsError({
                      ...isError,
                      amount: errorMessage,
                    })
                    setCouponDetail({ ...couponDetail, amount: value })
                  } else if (patten.test(e.target.value) && Number(value) > 0) {
                    setIsError({ ...isError, amount: '' })
                    setCouponDetail({ ...couponDetail, amount: value })
                  } else {
                    setIsError({
                      ...isError,
                      amount: errorMessage,
                    })
                  }
                }}
              />
              {isError.amount && <span className="text-red">{isError.amount}</span>}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">จำนวน: </label>
            <div className="col-sm-9">
              <input
                type="text"
                value={couponDetail.count}
                className="form-control"
                placeholder="กรุณากรอกจำนวนคูปอง"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '')
                  if (e.target.value === '') {
                    setIsError({
                      ...isError,
                      count: 'กรุณากรอกจำนวนคูปองให้ถูกต้อง',
                    })
                    setCouponDetail({ ...couponDetail, count: value })
                  } else if (patten.test(e.target.value) && Number(value) > 0) {
                    setIsError({ ...isError, count: '' })
                    setCouponDetail({ ...couponDetail, count: value })
                  } else {
                    setIsError({
                      ...isError,
                      count: 'กรุณากรอกจำนวนคูปองให้ถูกต้อง',
                    })
                  }
                }}
              />

              {isError.count && <span className="text-red">{isError.count}</span>}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={() => handleCloseModal()}>
          ยกเลิก
        </Button>
        <Button
          key="submit"
          disabled={isError.amount !== '' || isError.count !== ''}
          className={isError.amount !== '' || isError.count !== '' ? 'btn btn-dark' : 'btn btn-primary'}
          onClick={() => handleSubmitModal()}
        >
          สร้างคูปอง
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
